import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SkladOzn: [],
		NdpohybPzn: [],
		VyrobekndOzn: [],
		VydejMjId: [],
		Provozovna: [],
		ZakazkaDruh: [],
	},
	edit: {
		SkladOzn: null as number | null,
		ProvozovnaOzn: null as number | null,
		VyrobekndOzn: null as number | null,
		RabatSk: null as string | null,
		RabatSkText: null as string | null,
		NdpohybPzn: null as number | null,
		Text: null as string | null,
		DodavatelId: null as number | null,
		DodavatelIdText: null as string | null,
		VstupDat: null as string | null,
		NdNr: null as string | null,
		ZbozidruhOzn: null as string | null,
		ZbozidruhOznText: null as string | null,
		Skladmisto: null as string | null,
		SkladmistoText: null as string | null,
		Terminal: null as string | null,
		Pc: null as number | null,
		Nc: null as number | null,
		Pnc: null as number | null,
		Stav: null as number | null,
		VydejMjPoc: null as number | null,
		VydejMjId: null as string | null,
		VydejMj: null as string | null,
		Pohyb: null as number | null,
		ZakazkaNr: null as number | null,
		DokladPfx: null as string | null,
		DokladNr: null as number | null,
		StrednaklOznText: null as string | null,
		MimoKusPrp: null as boolean | null,
		ZakazkaDruhText: null as string | null,
		DodaciNr: null as number | null,
		ProvozovnaId: null as number | null,
		SkladMj: null as string | null,
		PracovnikIdText: null as string | null,
		VstupPracIdText: null as string | null,
		PnvId: null as number | null,
		ZakaznikId: null as number | null,
		ZakaznikIdText: null as string | null,
		ObjednNr: null as number | null,
		FumsKor: null as number | null,
		MarketKod: null as string | null,
		UzavapId: null as number | null,
		StrednaklOzn: null as number | null,
		VstupProvId: null as number | null,
		UzaDoDat: null as string | null,
		ZakazkaDruh: null as string | null,
	},
	localState: {},
	depTableNames: [],
	depTableSettings: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[editMutations.ND_POHYB_ZBOZI_SELECT_MAPPER](state, { data }) {
			state.edit.ZbozidruhOzn = data.value;
			state.edit.ZbozidruhOznText = data.text;
		},
		[editMutations.ND_POHYB_SKLAD_MISTO_SELECT_MAPPER](state, { data }) {
			state.edit.Skladmisto = data.value;
			state.edit.SkladmistoText = data.text;
		},
		[editMutations.ND_POHYB_RABAT_SK_SELECT_MAPPER](state, { data }) {
			state.edit.RabatSk = data.value;
			state.edit.RabatSkText = data.text;
		},
		[editMutations.ND_POHYB_DODAVATEL_SELECT_MAPPER](state, { data }) {
			state.edit.DodavatelId = data.value;
			state.edit.DodavatelIdText = data.text;
		},
		[editMutations.ND_POHYB_NAKLADOVE_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.ProvozovnaId = data.provozovnaId;
			}
		},
	},
	props: {
		mode: null,
	},
});
